module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', [_c('el-tab-pane', {
    attrs: {
      "label": "BaseInfo Configuration"
    }
  }, [(_vm.formData) ? _c('el-form', {
    ref: "projectInfoForm",
    staticClass: "pop-form-wrap width-box w600",
    attrs: {
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Seo Title",
      "prop": "ScSeoTitle"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.ScSeoTitle),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ScSeoTitle", $$v)
      },
      expression: "formData.ScSeoTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Seo Description",
      "prop": "ScSeoDescription"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "autosize": {
        minRows: 4
      },
      "type": "textarea"
    },
    model: {
      value: (_vm.formData.ScSeoDescription),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ScSeoDescription", $$v)
      },
      expression: "formData.ScSeoDescription"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Seo Key",
      "prop": "ScSeoKey"
    }
  }, [_vm._l((_vm.dynamicTags), function(tag) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.handleClose(tag)
        }
      }
    }, [_vm._v("\n            " + _vm._s(tag) + "\n          ")])
  }), _vm._v(" "), (_vm.inputVisible) ? _c('el-input', {
    ref: "saveTagInput",
    staticClass: "input-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "blur": _vm.handleInputConfirm
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleInputConfirm($event)
      }
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  }) : _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.showInput
    }
  }, [_vm._v("+ New Tag")])], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Custom Telephone",
      "prop": "ScTelephone"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.ScTelephone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ScTelephone", $$v)
      },
      expression: "formData.ScTelephone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Company Email",
      "prop": "ScEmail"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.ScEmail),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ScEmail", $$v)
      },
      expression: "formData.ScEmail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('projectInfoForm')
      }
    }
  }, [_vm._v("Save")])], 1)])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Advanced Configuration"
    }
  }, [(_vm.formData) ? _c('el-form', {
    ref: "infoForm",
    staticClass: "pop-form-wrap width-box w600",
    attrs: {
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Statistical Code",
      "prop": "ScStatisticalcode"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "textarea"
    },
    model: {
      value: (_vm.formData.ScStatisticalcode),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ScStatisticalcode", $$v)
      },
      expression: "formData.ScStatisticalcode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Js Code",
      "prop": "ScJscode"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "textarea"
    },
    model: {
      value: (_vm.formData.ScJscode),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ScJscode", $$v)
      },
      expression: "formData.ScJscode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Business Code",
      "prop": "ScBusinesscode"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "textarea"
    },
    model: {
      value: (_vm.formData.ScBusinesscode),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ScBusinesscode", $$v)
      },
      expression: "formData.ScBusinesscode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.update2DataAjax('infoForm')
      }
    }
  }, [_vm._v("Save")])], 1)])], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-12d670c8","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/other/WelcomeForm.vue
// module id = 730
// module chunks = 1